import React from "react";
import { ArrowUpRight, Zap } from "lucide-react";
import { usePrice } from "@/lib/price";

export default function FinalCTA() {
  const { price } = usePrice();
  return (
    <section
      data-testid="final-cta"
      className="relative border-b-4 border-[#0a0a0a] bg-[#FFE600] overflow-hidden"
    >
      <div className="absolute inset-0 bg-grid opacity-20 pointer-events-none" />
      <div className="absolute -bottom-20 -right-20 w-[420px] h-[420px] rounded-full bg-[#0055FF] border-4 border-[#0a0a0a] hidden md:block" />

      <div className="relative max-w-[1400px] mx-auto px-5 md:px-10 py-24 md:py-36 text-center">
        <div className="inline-flex items-center gap-2 bg-[#0a0a0a] text-[#FFE600] border-2 border-[#0a0a0a] px-3 py-1.5 font-accent text-sm shadow-brutal-sm mb-7">
          <Zap size={16} strokeWidth={3} /> ONE-TIME {price} · LIFETIME ACCESS ·
          NO RECURRING
        </div>
        <h2 className="font-display text-[44px] sm:text-6xl md:text-8xl lg:text-[8rem] leading-[0.92] md:leading-[0.88]">
          Stop searching.
          <br />
          <span className="bg-[#0a0a0a] text-[#FFE600] px-3">Start hacking.</span>
        </h2>
        <p className="mt-7 max-w-2xl mx-auto font-mono-body text-base md:text-lg">
          You&apos;ve read enough. Spin up a free account and put the entire
          toolkit to work in the next 60 seconds.
        </p>

        <div className="mt-10 flex flex-col sm:flex-row gap-4 justify-center">
          <a
            href="/login"
            data-testid="final-cta-free"
            className="hover-pop inline-flex items-center justify-center gap-2 bg-[#0055FF] text-white border-4 border-[#0a0a0a] px-8 py-5 font-accent text-xl md:text-2xl shadow-brutal"
          >
            Start Free <ArrowUpRight size={22} strokeWidth={3} />
          </a>
          <a
            href="https://whop.com/checkout/plan_hfsvR7lsOjQds"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="final-cta-lock"
            className="hover-pop inline-flex items-center justify-center gap-2 bg-[#0a0a0a] text-[#FFE600] border-4 border-[#0a0a0a] px-8 py-5 font-accent text-xl md:text-2xl shadow-brutal"
          >
            GET ALL TOOLS FOR {price}
          </a>
        </div>
        <p className="mt-6 font-mono-body text-xs text-[#0a0a0a]/70">
          Powered by Whop · 7-day refund · no recurring · no countdown
        </p>
      </div>
    </section>
  );
}
